import type { ReceivablePeriodDetailRow } from '../../api/paymentApi';
import { getPreviousBillingPeriod } from '../../utils/feeBillingTiming';

export interface ReceivableDebtPeriodSummary {
  previousPeriod: string;
  collectionPeriod: string;
  /** Nợ đầu kỳ (công nợ cuối kỳ trước). */
  previousPeriodDebt: number;
  periodIncurred: number;
  /** Phải thu trong kỳ (TB kỳ). */
  receivableInPeriod: number;
  /** Thanh toán phí trong kỳ (VII). */
  periodCollected: number;
  /** Nợ cuối kỳ (XI). */
  periodUncollected: number;
}

export function buildReceivableDebtPeriodSummary(
  totals: ReceivablePeriodDetailRow | null | undefined,
  collectionPeriod: string,
): ReceivableDebtPeriodSummary | null {
  if (!totals) return null;
  return {
    previousPeriod: getPreviousBillingPeriod(collectionPeriod),
    collectionPeriod,
    previousPeriodDebt: totals.openingDebit,
    periodIncurred: totals.totalIncurred,
    receivableInPeriod: totals.receivableThisMonth,
    periodCollected: totals.totalPayment,
    periodUncollected: totals.closingDebit,
  };
}
